import axios from "axios";

const AxiosInstance= axios.create({
    //baseURL: "https://localhost:7142/",
    baseURL: "https://btapi.alhindit.com",
    headers: {
        'Content-Type': 'application/json',
    }
})
export default AxiosInstance;